import ITheme from '../ITheme';

export default class ThemeKirjaclub implements ITheme {
  vuetifyTheme: any = {
    primary: '#212121',
    secondary: '#df9c20',
  };
}
